import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-field-error-display',
  templateUrl: './field-error-display.component.html',
  styleUrls: ['./field-error-display.component.css']
})
export class FieldErrorDisplayComponent {

  @Input() errorMsg: string;
  @Input() displayError: boolean;

}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/shared/components/field-error-display/field-error-display.component.ts